import { memo } from 'react';
import { PropertiesSection, Property } from './PropertiesSection';
import { T } from '../../../translation/src';
import { usePointClusterProperties } from '../../../hooks/potree/usePointClusterProperties';
import { ConvertType, useFormatNumber } from '../../../hooks/useFormatNumber';
import { PropertyPanel } from '../../Properties/components/PropertyPanel';
import { AnnotationType } from '../../Properties/types';
import { usePropertyValue } from '../../Properties/reactive';
import { getPointClusterSegmentsProperty } from '@pointorama/potree-shared';

interface PointClusterPropertiesProps {
  projectId: string;
  identifier: string;
}

const PointClusterProperties_: React.FC2<PointClusterPropertiesProps> = ({ projectId, identifier }) => {
  const segments = usePropertyValue(getPointClusterSegmentsProperty(identifier));
  const { pointCount } = usePointClusterProperties(segments);
  const { formatNumber } = useFormatNumber();

  return (
    <div className="flex flex-col space-y-4 divide-y divide-gray-800">
      <PropertiesSection title={<T _str="information" swc />}>
        <Property title={<T _str="type" swc />}>
          <T _str="point cluster" swc />
        </Property>
        <Property title={<T _str="number of points" swc />}>{formatNumber(pointCount || 0, { convertType: ConvertType.NONE, addUnit: false })}</Property>
        <Property title={<T _str="Number of segments" swc />}>{formatNumber(segments.length || 0, { convertType: ConvertType.NONE, addUnit: false })}</Property>
      </PropertiesSection>
      <PropertyPanel projectId={projectId} annotationTypes={[AnnotationType.POINTCLUSTER]} objectIdentifiers={[identifier]} />
    </div>
  );
};
export const PointClusterProperties = memo(PointClusterProperties_);
